import React, { useEffect, useState } from 'react';
import { MARKS } from '../../../constants/columns';
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { carsOptions } from '../../../constants/filterOptions';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import getModels from '../../../api/cars/getModels';
import deleteModel from '../../../api/cars/deleteModel';

// components
import Header from '../../../components/Header/Header';
import Table from '../../../components/Table/Table';
import TableTabs from '../../../components/TableTabs/TableTabs';
import Empty from '../../../components/Empty/Empty';
import ConfirmModal from '../../../components/Modal/ConfirmModal';

import alert from '../../../helpers/alert';
import extractErrorMessage from '../../../utils/extractErrorMessage';
import { ROLE_ADMIN } from '../../../constants/roles';

// icons
import icon from '../../../brand/generated/sidebar/cars.svg';
import bucketIcon from '../../../brand/generated/popover/delete.svg';

const columns = MARKS;

const CarModels = () => {
  const navigate = useNavigate();
  const roleId = useSelector((state) => state?.user?.roleId);
  const [loading, setLoading] = useState(true);
  const [models, setModels] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: 10,
  });
  const [isFetchAll, setFetchAll] = useState(false);

  const table = useTable(
    {
      columns,
      data: models,
      initialState: {
        pageSize: pagination.pageSize,
      },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
      disableSortRemove: true,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { setGlobalFilter, page, setPageSize } = table;

  const [value, setValue] = useState('');
  const [queryParams, setQueryParams] = useState({});
  const [deleteRow, setDeleteRow] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleNavigate = () => {
    navigate('/cars/models/create');
  };

  const init = (page) => {
    setLoading(true);
    getModels({ ...page })
      .then((res) => {
        setModels(res.data.models);
        setPagination({
          ...res.data.pagination,
          page: res.data.pagination?.pageNumber,
          pageSize: pagination.pageSize,
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!isFetchAll) {
      init({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    }
  }, [pagination.page, pagination.pageSize, queryParams]);

  // ÐÑÐºÐ°Ð·Ñ Ð±ÑÐºÐ° Ð¾ÑÐ¼ÑÑÐ»ÐµÐ½Ð½ÑÐµ (Â«Ðº Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸Â», Â«ÐµÑÑÑ
  // ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸Â»), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¸Ñ ÐºÐ°Ðº ÐµÑÑÑ.
  const run = async (action, successText) => {
    setSaving(true);
    try {
      await action();
      alert.success(successText);
      setDeleteRow(null);
      init({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || e?.message || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸ÑÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ');
    } finally {
      setSaving(false);
    }
  };

  // Ð£Ð´Ð°Ð»ÐµÐ½Ð¸Ðµ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ° â ÑÐ¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÑ; Ð±ÑÐº Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ ÑÑÐ¾ Ð¶Ðµ ÑÐ°Ð¼.
  const popover =
    roleId === ROLE_ADMIN
      ? [{ title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ', icon: bucketIcon, onClick: (row) => setDeleteRow(row) }]
      : undefined;

  return (
    <>
      <Header title="ÐÐ¾Ð´ÐµÐ»Ð¸" icon={icon} />
      <TableTabs
        setFilter={setGlobalFilter}
        options={carsOptions}
        value={value}
        setValue={setValue}
        navigate={handleNavigate}
        button={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ'}
        inputPlaceholder={'ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð¼Ð¾Ð´ÐµÐ»ÑÐ¼'}
      />
      <br />
      {!page.length && !loading ? (
        <Empty />
      ) : (
        <Table
          table={table}
          all={'Ð¼Ð°ÑÐ¾Ðº'}
          p={pagination}
          loading={loading}
          pagination
          setPagination={setPagination}
          setFetchAll={setFetchAll}
          isFetchAll={isFetchAll}
          setData={setModels}
          setLoading={setLoading}
          queryParams={queryParams}
          api={'/api/crm/cars/getModels'}
          response={'models'}
          popover={popover}
        />
      )}

      <ConfirmModal
        isOpen={Boolean(deleteRow)}
        onClose={() => setDeleteRow(null)}
        title="Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ"
        text={`Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ Â«${deleteRow?.name || ''}Â»? ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð½ÐµÐ¾Ð±ÑÐ°ÑÐ¸Ð¼Ð¾.`}
        loading={saving}
        onConfirm={() => run(() => deleteModel({ id: deleteRow.id }), 'ÐÐ¾Ð´ÐµÐ»Ñ ÑÐ´Ð°Ð»ÐµÐ½Ð°')}
      />
    </>
  );
};

export default CarModels;
